import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { Text } from '../../text/text.component';
import { useTemplateEditorValue, useTemplateSettings } from '../message-template.context';
import { MessageTemplateStyles } from '../message-template.styles';
import { getNodeCharCount } from './get-node-char-count';
import { CharCountOptions } from './get-template-char-count';

type TemplateCharCountProps = CommonHTMLAttributes &
  CharCountOptions & {
    hasError?: boolean;
    limit?: number;
  };

export const TemplateCharCount = ({ hasError, limit, trimWhitespace }: TemplateCharCountProps) => {
  const templateCharCountStyles = MessageTemplateStyles.templateCharCount;
  const nodes = useTemplateEditorValue();
  const { shortenUrlsTo } = useTemplateSettings();

  return (
    <div className={cx('message-template-char-count', templateCharCountStyles)}>
      <Text size='large' weight='bold' as='span' color={hasError ? 'error' : 'default'}>
        {getNodeCharCount(nodes, { shortenUrlsTo, trimWhitespace })}
        {Number.isInteger(limit) && ` / ${limit}`}
      </Text>
      <Text as='span' size='small' color={hasError ? 'error' : 'default'}>
        {' '}
        characters
      </Text>
    </div>
  );
};
